import { Button, Drawer, Dropdown, notification, Row, Space, Spin, Upload } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Select2, Text1 } from '../../../Components/FormComponents/InputFields';
import { MdInbox } from 'react-icons/md';
import { BiChevronDown } from 'react-icons/bi';
import { AddPolicyApi } from '../../../Services/CompanyPolicies';
import { LoadingOutlined } from '@ant-design/icons';
import { useOutletContext } from 'react-router-dom';


const { Dragger } = Upload;

 export default function AddPolicy ( { open, onClose, policyNames, getMenuItems } ) {
    const {dropDowns} = useOutletContext();

    const dropdownRef = useRef();

    const { control, formState: {errors}, handleSubmit, reset, resetField, setValue } = useForm();
    const [api, contextHolder] = notification.useNotification();

    const [ filteredPolicyNames, setFilteredPolicyNames ] = useState(null);

    const [ submitLoader, setSubmitLoader ] = useState(false);  

    const onSubmit = async (val) => {

      let formData = new FormData();

      formData.append('type', val.type);
      formData.append('department', val.department);
      formData.append('name', val.policyName);
      formData.append('file', val.policyPdf[0]);

      try {
        setSubmitLoader(true);
        const data = await AddPolicyApi(formData);
        setSubmitLoader(false);

        console.log(data);

        if (data.data.success) {
          api.success({
            message: data.data.message,
            placement: 'top'
          });
          getMenuItems();
        }
        else {
          api.error({
            message: 'Error while Adding Policy',
            description: data.data.message,
            placement: 'top'
          });
        }
      }
      catch (err) {
        setSubmitLoader(false);
        api.error({
          message: err.message,
          description: 'Try to check your Internet Connection.',
          placement: 'top'
        });
      }
    }


    const onPdfUpload = (val, setFile) => {

      if (val[0].type==='application/pdf') {
        setFile(val);
        return false;

      }
      else {
        return Upload.LIST_IGNORE;
      }
    }

    const onSelectPolicyName = (val, setPolicyName) => {
      setValue('policyName', val.key, { shouldValidate: true });
    }

    const getFilteredPolicyNames = (val) => {
      let temp = [];
      var reg = new RegExp(val, 'i')
      policyNames.map((ele) => {
        if (ele.key.search(reg) !== -1) {
          temp = temp.concat(ele);
        }
      })
      val === '' ?
      setFilteredPolicyNames(policyNames) :
      setFilteredPolicyNames(temp);
    }

    useEffect(() => {
      setFilteredPolicyNames(policyNames);
      if (open) {
        resetField('policyName');
        resetField('policyPdf');
      }
      else {
        reset();
      }
    }, [onClose, reset])

  return (
    <>
      { contextHolder }
      <Drawer
        title="Add New Policy"
        onClose={onClose}
        open={open}
        contentWrapperStyle={{width: '100vw'}}
        bodyStyle={{
          paddingBottom: 80,
          
        }}
        footer={
          <Space size='middle'>
            <Button size='large' onClick={onClose}>Cancel</Button>
            <Button size='large' onClick={handleSubmit(onSubmit)} type="primary">
              { submitLoader && <Spin className='mr-2 mb-2' size='default' indicator={<LoadingOutlined className='text-light' />} spinning={true}/>}
              Submit
            </Button>
          </Space>
        }
        footerStyle={{textAlign: 'right'}}
      >
            <Row>
                <Select2 control={control} errors={errors} validations={ { required: true } } id='type' name='Type' options={dropDowns && dropDowns.COMPANY_FILE_TYPE} />
                <Select2 control={control} errors={errors} validations={ { required: true } } id='department' name='Department' options={dropDowns && dropDowns.COMPANY_FILE_TYPES_DEPARTMENTS} />

                <Text1 
                  control={control} 
                  errors={errors} 
                  validations={ { required: true } } 
                  id='policyName' 
                  noHtmlId
                  name='Policy Name' 
                  onChange={getFilteredPolicyNames}
                  onClick={() => dropdownRef.current.click()}
                  logo={
                    <div>
                      <Dropdown menu={{items: filteredPolicyNames, onClick: onSelectPolicyName}} dropdownRender={(menu) => React.cloneElement(menu, {style: {width: '434px', transform: 'translateX(12px)', maxHeight: '200px', overflow: 'auto'}})} trigger={['click']}>
                        <div>
                          <button className='d-none' ref={dropdownRef}></button>
                          <BiChevronDown className='fs-4 text-secondary' />
                        </div>
                      </Dropdown>
                    </div>
                  } 
                />

                <Controller
                  name='policyPdf'
                  control={control}
                  defaultValue={[]}
                  rules={{ required: true }}
                  render={({ field }) => 
                    <Dragger 
                      className='w-100 mx-3 mt-4' beforeUpload={(temp, val) => onPdfUpload(val, field.onChange)} 
                      listType='picture'
                      accept='application/pdf'
                      maxCount={1}
                      fileList={field.value}
                      onRemove={() => field.onChange([])}
                    >
                      <p className="ant-upload-drag-icon">
                        <MdInbox className='fs-1 text-info' />
                      </p>
                      <p className="ant-upload-text">Click or drag file to this area to upload</p>
                      <p className="ant-upload-hint">
                        Support for a single PDF file.
                      </p>
                    </Dragger>
                  }
                />
                {errors && errors.policyPdf?.type === 'required' && <span className='mx-3 text-danger' style={{ fontSize: '13px', bottom: '-20px'}} role="alert">Please Select a File.</span>}

            </Row>
      </Drawer>
    </>
  );
};